import { parse as parseUrl } from '@sosocio/frontend-utils/url';

export default parseUrl;
